import classNames from 'classnames';
import React from 'react';
import { DivProps } from '../../../../../typings';
import getFontSize from '../../../domain/helpers/get-font-size';
import { Header } from '../typography';
import Counter from './counter';

interface Props extends DivProps {
  value: number;
  setValue: (value: number) => void;
  disabled?: boolean;
}

function Period(props: Props) {
  const { value, setValue, disabled, ...rest } = props;

  const fontSize = getFontSize({
    mobile: 60,
    tablet: 80,
    desktop: 100,
  });

  return (
    <div {...rest} className={classNames('flex-center period flex-col gap-4', rest.className)}>
      <Header id="header">тайм</Header>
      <Counter disabled={disabled} value={value} setValue={setValue} fontSize={fontSize} />
    </div>
  );
}

export default Period;
